import { GROUP_ENDPOINT } from '../config/api-endpoints'
import { authorizeHeader } from '../utils/auth-header'
import { v4 as uuidV4 } from 'uuid'
import { uploadFile } from '../utils/azure-blob-helpers'
import i18n from '../i18n';

import {
  showNotificationForUploadInProgress,
  showNotificationForUploadFailed,
  showNotificationForUploadEnd
} from '../utils/notification-helpers'

export const getGroupAPICall = async () => {
  try {
    const config = {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    }
    const response = await window.fetch(GROUP_ENDPOINT, authorizeHeader(config))
    const responseOk = await response.status === 200
    const responseJSON = await response.json()
    return { responseOk, responseJSON }
  } catch (e) {
    console.error('ERROR: ', e)
    return e
  }
}

export const getCheckGroupAPICall = async ({ userGroupName }) => {
  try {
    const config = {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    }
    const response = await window.fetch(GROUP_ENDPOINT + '/' + encodeURIComponent(userGroupName), authorizeHeader(config))
    const responseOk = await response.status === 200
    const responseJSON = await response.json()
    return { responseOk, responseJSON }
  } catch (e) {
    console.error('ERROR: ', e)
    return e
  }
}

export const postCreateGroupAPICall = async ({
  userGroupName,
  address,
  email_address,
  accountType,
  organization_type,
  org_structure,
  confirm_create
}) => {
  try {
    const body = { name: userGroupName, address, email_address }
    if (organization_type) body.organization_type = organization_type
    if (org_structure) body.org_structure = org_structure
    // Only send the override after the user explicitly confirms the soft
    // name-match gate. A false/missing value must retain backend dedupe checks.
    if (confirm_create === true) body.confirm_create = true

    const config = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(body)
    }
    const response = await window.fetch(GROUP_ENDPOINT + `?new-customer=yes&account-type=${accountType}`, authorizeHeader(config))
    const responseStatus = response.status
    const responseOk = response.status === 200
    let responseJSON = null

    // Non-2xx responses, especially the corporate-domain 409, contain data
    // required by the signup flow. Do not throw before preserving that body.
    try {
      responseJSON = await response.json()
    } catch (e) {
      // The saga still receives the status and can show a deterministic error
      // when an upstream proxy returns an empty or non-JSON response.
    }

    return { responseOk, responseStatus, responseJSON }
  } catch (e) {
    console.error('ERROR: ', e)
    return {
      responseOk: false,
      responseStatus: null,
      responseJSON: null,
      error: e
    }
  }
}


export const postUpdateGroupAPICall = async ({ userGroupCountry, userGroupEmail, userGroupName, userPhone, userGroupLogo, website, groupId, containerURL, aiSettings }) => {
  try {
    let logo = ''
    const t = i18n.t;
    if (containerURL) {
      const notification = {
        notificationKey: 'upload',
        message: t("apis.groups.post_update_message"),
        content: t("apis.upload_image_file")
      }

      const file = userGroupLogo[0]
      const fileName = `${groupId}-${uuidV4()}.${file.name.split('.', -1)[1]
        }`

      const response = await uploadFile({ containerURL, file, fileName, showNotificationForUploadInProgress, showNotificationForUploadFailed, notification })
      if (response) {
        logo = `https://teleradsettings.blob.core.windows.net/grouplogos/${fileName}`
      }
      showNotificationForUploadEnd(notification)

    }
    const patchBody = { location: userGroupCountry, email_address: userGroupEmail, name: userGroupName, logo, website: website, office_number: userPhone && userPhone.phone }
    if (aiSettings) Object.assign(patchBody, aiSettings)

    const config = {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(patchBody)
    }
    const response = await window.fetch(GROUP_ENDPOINT, authorizeHeader(config))
    const responseOk = await response.status === 200
    const responseJSON = await response.json()
    return { responseOk, responseJSON }
  } catch (e) {
    console.error('ERROR: ', e)
    return e
  }
}
